import * as React from "react";

export const TextArea = ({ column, value, handleChange, disabled }) => (
	<textarea
		className="form-control editor edit-text"
		rows={column.lines}
		defaultValue={value}
		disabled={disabled}
		onChange={(event: React.ChangeEvent<HTMLTextAreaElement>) => handleChange(event.target.value)}
	/>
);
